import { Popover as PopoverPrimitive } from 'radix-ui';
import * as React from 'react';

import { useShadowRoot } from './ShadowRootContext';
import { cn } from './utils/cn';

const Popover = PopoverPrimitive.Root;

const PopoverTrigger = PopoverPrimitive.Trigger;

const PopoverAnchor = PopoverPrimitive.Anchor;

const PopoverClose = PopoverPrimitive.Close;

const popoverContentClasses = cn([
  'pointer-events-auto z-50 w-72 rounded-md border bg-bg-primary p-4 text-text-primary shadow-md outline-hidden',
  'data-[state=open]:animate-in data-[state=open]:fade-in-0 data-[state=open]:zoom-in-95',
  'data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95',
  'data-[side=bottom]:slide-in-from-top-2',
  'data-[side=left]:slide-in-from-right-2',
  'data-[side=right]:slide-in-from-left-2',
  'data-[side=top]:slide-in-from-bottom-2',
]);

const PopoverContent = React.forwardRef<
  React.ElementRef<typeof PopoverPrimitive.Content>,
  React.ComponentPropsWithoutRef<typeof PopoverPrimitive.Content> & {
    usesPortal?: boolean;
  }
>(
  (
    { className, align = 'center', sideOffset = 4, usesPortal, ...props },
    ref,
  ) => {
    const { container } = useShadowRoot();

    const content = (
      <PopoverPrimitive.Content
        ref={ref}
        align={align}
        sideOffset={sideOffset}
        className={cn(popoverContentClasses, className)}
        collisionBoundary={container}
        collisionPadding={container ? { top: 50 } : undefined}
        {...props}
      />
    );

    if (usesPortal === false) {
      return content;
    }

    return (
      <PopoverPrimitive.Portal container={container}>
        {content}
      </PopoverPrimitive.Portal>
    );
  },
);
PopoverContent.displayName = PopoverPrimitive.Content.displayName;

export { Popover, PopoverTrigger, PopoverAnchor, PopoverContent, PopoverClose };
